import React from 'react';

import { useRestrictedActionShowState, useRestrictedActionShowActions } from './RestrictedActionShowContext';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { addUserToRestrictedAction } from './restApi';

const AddUserForm = ({ restrictedAction }) => {
  const state = useRestrictedActionShowState();
  const { onResponse, onError, updateNewUserId, closeAddUserModal } = useRestrictedActionShowActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    addUserToRestrictedAction({
      restrictedAction,
      onResponse,
      onError,
      body: {
        newUser: state?.newUser,
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="User ID" id="userId">
        <Input
          type="text"
          value={state?.newUser?.id || ''}
          onChange={(e) => {
            updateNewUserId(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeAddUserModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Add User
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default AddUserForm;
